import { motion } from "framer-motion";
import { Heart, TrendingUp } from "lucide-react";

const DemoHealthScore = () => {
  const score = 87;

  return (
    <div className="bg-gradient-to-br from-emerald-50 to-emerald-100/50 rounded-2xl p-3 border border-emerald-200/50">
      <div className="flex items-center gap-3">
        {/* Animated Score Circle */}
        <div className="relative">
          <svg className="w-14 h-14 -rotate-90">
            <circle
              cx="28"
              cy="28"
              r="24"
              stroke="currentColor"
              strokeWidth="4"
              fill="none"
              className="text-emerald-200"
            />
            <motion.circle
              cx="28"
              cy="28"
              r="24"
              stroke="currentColor"
              strokeWidth="4"
              fill="none"
              strokeLinecap="round"
              className="text-emerald-600"
              initial={{ strokeDasharray: "0 151" }}
              whileInView={{ strokeDasharray: `${(score / 100) * 151} 151` }}
              viewport={{ once: true }}
              transition={{ duration: 1.5, ease: "easeOut", delay: 0.5 }}
            />
          </svg>
          <div className="absolute inset-0 flex items-center justify-center">
            <Heart className="w-4 h-4 text-emerald-600" />
          </div>
        </div>

        {/* Score Info */}
        <div className="flex-1">
          <div className="flex items-center gap-1.5">
            <span className="text-[10px] text-slate-500 font-medium">Score de santé</span>
            <TrendingUp className="w-3 h-3 text-emerald-500" />
          </div>
          <motion.div
            className="text-2xl font-bold text-emerald-700"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.8 }}
          >
            {score}/100
          </motion.div>
          <p className="text-[10px] text-emerald-600 font-medium">Excellent ! 🌱</p>
        </div>
      </div>
    </div>
  );
};

export default DemoHealthScore;
